// The following line loads the standalone build of Vue instead of the runtime-only build,
// so you don't have to do: import Vue from 'vue/dist/vue'
// This is done with the browser options. For the config, see package.json
import Vue from 'vue'
import VueRouter from 'vue-router'
import VTooltip from 'v-tooltip'
import App from './app.vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import moment from 'moment'
import jwt_decode from "jwt-decode";
import config from './config'
import _ from 'lodash'
import LoginPage from './views/LoginPage.vue'
//import AirportPage from './views/NewTripPage.vue'
import NewTripPage from './views/NewTripPage.vue'
import EditTripPage from './views/EditTripPage.vue'
import ActiveTripMobilePage from './views/ActiveTripMobilePage.vue'
import HomePage from './views/HomePage.vue'
import TripsPage from './views/TripsPage.vue'
import DriverTripStatusPage from './views/DriverTripStatusPage.vue'
import VButton from './components/v-button.vue'

console.log("VUE VERTSION " + Vue.version);

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
})

// Global feature switch between staging and production
window.STAGING = config.config.env == 'staging';
window.ENV = config.config.env;
console.log('Environment is \"' + window.ENV +'\"');

// Only run Sentry.io reporting in the browserified production code, not in the watchified dev server
const SENTRY_DSN = process.env.SENTRY_DSN

if (SENTRY_DSN) {
    console.log('Initializing Sentry.io error reporting')
    Raven.config(SENTRY_DSN, {
        release: '0.0.0-4c237b6',
        environment:  (window.STAGING) ? 'staging' : 'production',
        ignoreUrls: [
            /localhost/,
            /127\.0\.0\.1/,
            /\.codeanyapp\.com/,
        ]
    })

    Raven.addPlugin(RavenVue, Vue)
    Raven.install()
}

// define global data plugins
const privateReactiveStore = new Vue({
    data: {
        user: null,
        drivers: [],
        locations: [],
        managers: [],
        productSpecialists: [],
        trips: [],
        delays: [],
        fromLogin: false
    },
    methods: {
        setFromLogin(justLoggedIn) {
            this.fromLogin = justLoggedIn;
        },
        getFromLogin() {
            return this.fromLogin;
        },
        setUser(user) {
            this.user = JSON.parse(JSON.stringify(user));
        },
        getUser() {
            return this.user;
        },
        setDrivers(drivers) {
            this.drivers = drivers;
        },
        isUserAuthenticated() {
            let authenticated = false;
            let authToken = localStorage.getItem('authToken');

            if(authToken) {
                let decoded = jwt_decode(authToken);
                let now = Math.round(Date.now() / 1000);
                let expired = decoded.exp < now;
                
                if(!expired) {
                    authenticated = true;

                    if(!this.user) {
                        let usr = decoded.data;

                        usr['id'] = decoded.sub;
                        this.$privateReactiveStore.setUser(usr);
                    }
                }

                return authenticated;
            }

            return this.user && localStorage.getItem('authToken');
        },
        getDrivers() {
            return this.drivers;
        },
        getDriver(id) {
            let drv = null;
            let drvFound = this.drivers.filter(d => d.id === id);

            if(Array.isArray(drvFound) || drvFound.length > 0) {
                drv = drvFound[0];
            }

            return drv;
        },
        updateDrivers() { 

        },
        setLocations(locations) {
            this.locations = locations;
        },
        getLocations() {
            return this.locations;
        },
        getLocation(id) {
            let loc = null;
            let locsFound = this.locations.filter(location => location.id === id);

            if(Array.isArray(locsFound) || locsFound.length > 0) {
                loc = locsFound[0];
            }

            return loc;
        },
        updateLocations() {

        },
        setManagers(managers) {
            this.managers = managers;
        },
        getManagers() {
            return this.managers;
        },
        getManager(id) {
            let mgr = null;
            let mgrFound = this.managers.filter(m => m.id === id);

            if(Array.isArray(mgrFound) || mgrFound.length > 0) {
                mgr = mgrFound[0];
            }

            return mgr;
        },
        updateManager() {

        },
        setProductSpecialists(prodSpecs) {
            this.productSpecialists = prodSpecs;
        },
        getProductSpecialists() {
            return this.productSpecialists;
        },
        getProductSpecialist(id) {
            let ps = null;
            let psFound = this.productSpecialists.filter(ps => ps.id == id);
            
            if(Array.isArray(psFound) || psFound.length > 0) {
                ps = psFound[0];
            }

            return ps;
        },
        setDelays(delays) {
            this.delays = delays;
        },
        getDelays() {
            return this.delays;
        },
        getDelay(delayId) {
            let delay = null;

            this.delays.forEach(function(d) {
                if(d.id == delayId) {
                    delay = d;
                }
            });

            return delay;
        },
        getDelaysInStage(stage) {
            let delaysInStage = []; 

            this.delays.forEach(function(d) {
                if(d.stage == stage) {
                    delaysInStage.push(d);
                }
            }); 
            
            return delaysInStage;
        },
        setTrips(trips) {
            this.trips = trips;
        },
        getTrips() {
            return this.trips;
        },
        getTrip(id) {
            let trip = null;

            this.trips.forEach(function(t) {
                if(t.id == id) {
                    trip = t;
                }
            });

            return trip;
        },
        isTripStillActive(id) {
            let active = false;
            let activeTrip = this.getTrip(id);
            
            if(activeTrip) {
                if(!activeTrip.cancled && !activeTrip.delivered) {
                    active = true;
                }
            }

            return active;
        },
        updateTrip(updateId, updateKeyValuePairs) { 
            console.log("UPDATE TRIP " + updateId);
            console.log("APP UPDATE TRIP " + JSON.stringify(updateKeyValuePairs));
            let tripToUpdateIndex = this.trips.findIndex(function(trip) {
                return trip.id == updateId;
            });
              
            // proceed to remove an item only if it exists.
            if(tripToUpdateIndex !== -1){
                let updatedTrips = JSON.parse(JSON.stringify(this.trips));
                let updatedTrip = JSON.parse(JSON.stringify(this.trips[tripToUpdateIndex]));
                
                Object.keys(updateKeyValuePairs).forEach( updateKey => {
                    console.log(" FOR FIELD " + updateKey + " SET VALUE TO " + JSON.stringify(updateKeyValuePairs[updateKey]));
                    updatedTrip[updateKey] = updateKeyValuePairs[updateKey];
                });

                updatedTrips[tripToUpdateIndex] = updatedTrip;
                this.trips = updatedTrips;
            }
        },
    }
});

// define install mthods for global data plugins
privateReactiveStore.install = function() {
    Object.defineProperty(Vue.prototype, '$privateReactiveStore', {
        get() {
            return privateReactiveStore;
        }
    });
};

//install vue router
Vue.use(VueRouter);

// install global data object plugins
Vue.use(privateReactiveStore);
Vue.use(VTooltip);

// install global components
Vue.use(LoginPage);
//Vue.use(AirportPage);
Vue.use(NewTripPage);
Vue.use(EditTripPage);
Vue.use(ActiveTripMobilePage);
Vue.use(HomePage);
Vue.use(TripsPage);
Vue.use(DriverTripStatusPage);

Vue.component('picker-modal', require('./components/picker-modal.vue'))
Vue.component('external-link', require('./components/external-link.vue'))
Vue.component('redirect-page', require('./components/redirect-page.vue'))
Vue.component('v-select', require('./components/v-select.vue'))
Vue.component('v-input', require('./components/v-input.vue'))
Vue.component('v-button', VButton)

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$socket = io(config.config.liveUrl);

const routes = [
    {path: '/login', name: 'login', component: LoginPage},
    //{name: 'AirportPage', path: '/airport', componenet: AirportPage},
    {name: 'NewTripPage', path: '/trips/new', component: NewTripPage, meta: {requiresAuth: true}},
    {name: 'EditTripPage', path: '/trips/:id/edit', component: EditTripPage, props: true, meta: {requiresAuth: true}},
    {name: 'ActiveTripMobilePage', path: '/active/:stock_num', component: ActiveTripMobilePage, props: true},
    {name: 'TripsPage', path: '/trips', component: TripsPage, meta: {requiresAuth: true}},
    {name: 'HomePage', path: '/',  component: HomePage},
    {name: 'DriverTripStatusPage', path: '/trips/driverActions/:tripId', component: DriverTripStatusPage, props: true, meta: {requiresAuth: true}},
    {name: 'DriverTripStatusPage', path: '/trips/driverActions', component: DriverTripStatusPage, props: true, meta: {requiresAuth: true}}
];

const router = new VueRouter({
    mode: 'history',
    routes: routes
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (privateReactiveStore.isUserAuthenticated()) {
            //console.log("LOGGED IN " + from.name);
            if(from.name == 'login') {
                privateReactiveStore.setFromLogin(true); 
            }
            else {
                privateReactiveStore.setFromLogin(false);
            }

            next();
            return;
        }

        next({name: 'login', query: { redirect: to.path }});
    } 
    else {
        next();
    }
});

const app = new Vue({
    el: '#app',
    render: h => h(App),
    router
});
